import { graphql } from 'gatsby'
import { normalizedData } from '@utils'
import Layout from '@layout'
import Header from '@layout/header/layout-01'
import Footer from '@layout/footer/layout-01'
import PageHeader from '@containers/page-header/layout-04'
import TextArea from '@containers/text/layout-01'
import VorstandArea from '@containers/vorstand-und-team/layout-01'
import TeamArea from '@containers/vorstand-und-team/layout-02'

const VorstandUndTeamPage = ({ location, data }) => {
  const content = normalizedData(data?.strapiPage?.content || [])

  return (
    <Layout location={location}>
      <Header />
      <main className="site-wrapper-reveal">
        <PageHeader
          data={{
            ...content['header-section']
          }}
        />
        <TextArea
          data={{
            ...content['einleitung-section']
          }}
        />
        <VorstandArea data={content['vorstand-section']} id="vorstand" />
        <TeamArea
          data={content['team1-section']}
          data2={content['team2-section']}
          id="team"
        />
      </main>
      <Footer />
    </Layout>
  )
}

export { Head } from '@components/head'

export const query = graphql`
  query VorstandUndTeamPageQuery($title: String, $locale: String) {
    strapiPage(
      title: { eq: $title }
      pageType: { eq: "innerpage" }
      locale: { eq: $locale }
    ) {
      content {
        ...StrapiPageContent
      }
      seo {
        ...StrapiPageSEO
      }
    }
  }
`

export default VorstandUndTeamPage
